const GettingStartedData = {
  slug: 'getting-started',
  sectionTitle: 'Getting Started with Spatial Grid',
  blocks: [
    {
      type: 'text',
      content: [
        'Spatial Grid is a powerful creation platform that enables you to design immersive **AR, VR, and XR experiences**, interactive simulations, and **3D animations**—all from a single workspace. Whether you’re building training scenarios, product visualizations, or interactive environments, Spatial Grid gives you the tools to bring spatial ideas to life.',
      ],
    },
  ],
  subSections: [
    {
      title: 'What You Can Create',
      blocks: [
        {
          type: 'text',
          content:
            'With Spatial Grid, you can design a wide range of spatial experiences, including:',
        },
        {
          type: 'list',
          items: [
            'Interactive **AR experiences** layered onto real-world environments',
            'Fully immersive **VR simulations** for training and visualization',
            '**XR environments** that blend physical and digital spaces',
            '**3D animations** with lighting, motion, and effects',
            'Guided walkthroughs and explainers using interactive scenes',
          ],
        },
      ],
    },
    {
      title: 'How Spatial Grid Helps You Create',
      blocks: [
        {
          type: 'text',
          content:
            'Spatial Grid simplifies complex spatial creation by offering:',
        },
        {
          type: 'list',
          // style: 'decimal',
          items: [
            'A **visual, grid-based 3D workspace** for precise placement and alignment',
            'Drag-and-drop creation of **3D objects, text, images, and effects**',
            'Built-in tools for **animation, lighting, and interactions**',
            'Real-time previews to quickly see how experiences behave',
          ],
        },
        {
          type: 'info',
          content:
            'No advanced coding is required to begin creating, making Spatial Grid accessible to both technical and non-technical teams.',
        },
      ],
    },
    {
      title: 'Built for Teams and Organizations',
      blocks: [
        {
          type: 'text',
          content:
            'Spatial Grid is designed for collaborative creation at scale:',
        },
        {
          type: 'list',
          items: [
            'Organize work within **projects and workspaces**',
            'Control access to features through **admin and feature activation settings**',
            'Enable advanced tools, including **AI-assisted creation**, when needed',
          ],
        },
      ],
    },
    {
      title: 'Where Spatial Grid Is Used',
      blocks: [
        {
          type: 'text',
          content:
            'Spatial Grid supports use cases across industries, such as:',
        },
        {
          type: 'list',
          items: [
            'Training and simulations',
            'Education and research',
            'Product visualization and demonstrations',
            'Design reviews and spatial storytelling',
            'Remote collaboration and knowledge sharing',
          ],
        },
      ],
    },
    {
      title: 'Why Start with Spatial Grid',
      blocks: [
        {
          type: 'list',
          items: [
            'Create immersive experiences faster',
            'Reduce complexity in spatial design workflows',
            'Collaborate easily across teams',
            'Scale from simple scenes to advanced simulations',
          ],
        },
      ],
    },
  ],
};

export default GettingStartedData;
